import { useLocation } from '@trello/router';

import { getRouteIdFromPathname } from './getRouteIdFromPathname';
import type { RouteId } from './routes';

export function useRouteId(): RouteId {
  const { pathname } = useLocation();
  return getRouteIdFromPathname(pathname);
}
